export default "__VITE_ASSET__DjTs0dkV__"